export default [
    {
        date: "2024.12.28",
        title: "My Best Selection 30",
        img: require("@/assets/home/news/BestSelection.png"),
        text: `
        作曲10周年記念<br>
      プレイリスト<a href="https://soundcloud.com/tyanmahou/sets/mybest" target="_blank">
    「My Best Selection 30」<br>
     </a>を公開しました。          
      `,
        link: {
            url: "https://soundcloud.com/tyanmahou/sets/mybest",
            external: true
        },
    },    
    {
        date: "2024.04.21",
        title: "ColorfulTone v4.0.1リリース",
        img: "https://colorfultone.tyanmahou.com/web/img/slide/Screenshot1.png",
        text: `
      <a href="https://colorfultone.tyanmahou.com/web/" target="_blank">
    「ColorfulTone」
     </a>のv4.0.1が正式リリース<br>また、「2024 春パック」が配信されました。<br>譜面のダウンロードはゲーム内から。          
      `,
        link: {
            url: "https://colorfultone.tyanmahou.com/web/",
            external: true
        },
    },
    {
        date: "2020.11.16",
        title: "LINEスタンプ販売開始",
        img: require("@/assets/works/goods/mahou-kun-stamp.png"),
        text: `LINEスタンプにて<a href="https://store.line.me/stickershop/product/13692750" target="_blank">
      「まほうくん スタンプ」<br /></a>販売開始！！<br>`,
        link: {
            url: "https://store.line.me/stickershop/product/13692750",
            external: true
        },
    },
];